import { addEditDataAPI } from "services/CRUDServices";
import { getPrice } from "tools/functions/Methods";

export const calculateSettlement = (data) => {
  const totalCredit = data.reduce(
    (sum, item) => sum + (item.creditorsLedger || 0),
    0
  );
  const totalDebtor = data.reduce(
    (sum, item) => sum + (item.debtorsLedger || 0),
    0
  );
  const result = totalCredit - totalDebtor;
  return result;
};

export const sync = (item, refreshTable) => {
  addEditDataAPI(
    `/core-api/hub_credit/syncCreateCreditByAllocation/${item.id}`,
    "post",
    {}
  ).then((res) => {
    refreshTable();
  });
};

export const calculateUsedCredit = (data, seprate=false) => {
  const totalCredit =
    data?.settlements.reduce(
      (sum, item) => sum + (item.creditorsLedger || 0),
      0
    ) || 0;
  const result = data.creditAmount - data.usedCredit + totalCredit;
  return seprate ? getPrice(result) : result;
};

export const credtiDetail = (item) => {
  addEditDataAPI(
    `/customer-api/subsidiaryLedger/findByCredit/${item.id}`,
    "post",
    {}
  );
};
